import { render } from "./ProviderDetailsOverlay.vue?vue&type=template&id=45637c90&scoped=true&lang=pug"
import script from "./ProviderDetailsOverlay.vue?vue&type=script&lang=js"
export * from "./ProviderDetailsOverlay.vue?vue&type=script&lang=js"

import "./ProviderDetailsOverlay.vue?vue&type=style&index=0&id=45637c90&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45637c90"]])

export default __exports__